module.exports = __webpack_public_path__ + "img/green-chart.288834f1.svg";